<div class="screen-selection-dialog" *ngIf="showDialog()">
  <div class="dialog-background">
    <div class="dialog-wrapper">
      <div class="dialog-content">
        <!-- Header -->
        <div class="dialog-header">
          <h3 class="dialog-title">{{ title }}</h3>
          <button class="close-button" (click)="cancel()" type="button">
            <i class="fa fa-times"></i>
          </button>
        </div>

        <!-- Simple Screen List -->
        <div class="screen-list">
          @if (currentSelectionsState.length > 0) {
          <div
            *ngFor="let screen of currentSelectionsState; let i = index"
            class="screen-item"
          >
            <div class="screen-checkbox">
              <rn-checkbox
                [checkboxModel]="screen.selected"
                [inputName]="'screen-' + i"
                [labelText]="screen.title"
                (checkboxModelChange)="onCheckboxChange(screen, $event)"
              >
              </rn-checkbox>
            </div>
            @if (screen.includeErrorState !== undefined && screen.selected) {
            <div class="screen-checkbox screen-checkbox--nested">
              <rn-checkbox
                [checkboxModel]="screen.includeErrorState"
                [inputName]="'screen-error-' + i"
                [labelText]="'Include error state'"
                (checkboxModelChange)="onErrorStateChange(screen, $event)"
              >
              </rn-checkbox>
            </div>
            }
          </div>
          }
        </div>

        <!-- Footer Actions -->
        <div class="dialog-footer">
          <button
            type="button"
            class="btn btn-primary"
            (click)="confirmSelection()"
          >
            Include In PDF
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
